export const formatCurrency = (value: number): string => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value);
};

export const formatPercentage = (value: number): string => {
  return `${value.toFixed(2)}%`;
};

export const formatDateDDMMYYYY = (timestamp: string): string => {
  const date = new Date(Number.parseInt(timestamp, 10));
  return new Intl.DateTimeFormat('en-GB', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  }).format(date);
};

export const calculateTimeInMarket = (entryTime: string, exitTime: string): string => {
  const entry = Number.parseInt(entryTime, 10);
  const exit = Number.parseInt(exitTime, 10);
  const diffMs = exit - entry;
  const diffHours = diffMs / (1000 * 60 * 60);

  if (diffHours < 24) {
    return `${diffHours.toFixed(1)}h`;
  }
  const days = Math.floor(diffHours / 24);
  const hours = diffHours % 24;
  return `${days}d ${hours.toFixed(1)}h`;
};

export const formatAverageHoldDuration = (hours: number): string => {
  if (!Number.isFinite(hours) || hours <= 0) {
    return '—';
  }
  if (hours < 24) {
    return `${hours.toFixed(1)}h`;
  }
  const days = Math.floor(hours / 24);
  const remainder = hours % 24;
  return `${days}d ${remainder.toFixed(1)}h`;
};
